<template>  
    <div class="flex flex-column py-2">
        <div class="flex flex-row align-items-center">
            <Button v-if="isUserInGroup('admin')" :label="(screenSize === 'xs' || screenSize === 'sm') ? '' : 'Экспорт'" 
                icon="pi pi-upload" size="small" text @click="exportCSV($event)" severity="info" class="flex"/>
            <Button label="Сбросить" icon="pi pi-filter" size="small" @click="resetFilter" class="border-round-lg border-0" severity="info" outlined/>
        </div>
    </div>  
    <DataTable v-if='list && !loading' :value="list" responsiveLayout="scroll" ref="dt" dataKey="id" class="w-full"
        :rows="lazyParams.rows" :rowsPerPageOptions="[5, 10, 20, 50, 100]" :totalRecords="totalRecords" lazy paginator
        @page="onPage($event)" @sort="onSort($event)" :loading="loading" 
        @filter="onFilter($event)" v-model:filters="filters" filterDisplay="menu" :globalFilterFields="['type', 'stock_type', 'from', 'to']" >

        <Column field="id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">ID</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 align-items-center" v-if="data.id">
                    <span class="flex text-xs my-auto overflow-hidden text-primary cursor-pointer" @click="goToCard(data.id)" style="max-width:4em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.id }}
                        </span>
                    </span>...
                    <Button icon="pi pi-copy" @click="copy(data.id)" size="small" class="border-round-md border-round-lg border-0" severity="secondary" outlined/>
                    <Button icon="pi pi-external-link" @click="goToCard(data.id, true)" size="small" class="border-round-md border-round-lg border-0" severity="info" outlined/>
                </div>
            </template>
        </Column>

        <Column field="card_number" >
            <template #header>
                <span class="text-xs">last4</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.id">
                    <span class="inline-block border-round-md border-0 surface-border" :style="getCardColorStyle(data.program_id)"></span>
                    <div class="flex flex-row gap-2 align-items-center font-medium" v-if="data.last4">
                        <span class="flex text-sm">...{{data.last4}}</span>
                        <Button icon="pi pi-copy" @click="copy(data.last4)" size="small" class="border-round-md border-round-lg border-0" severity="info" outlined/>
                    </div>
                </div>
            </template>
        </Column>

        <Column field="active" >
            <template #header>
                <span class="text-xs">active</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.active!=undefined">
                    <Tag :value="(data.active) ? 'Да' : 'Нет'" :severity="(data.active) ? 'secondary' : 'danger'" class="border-none text-xs"/>
                </div>
            </template>
        </Column>

        <Column field="balance">
            <template #header>
                <span class="text-xs font-medium">Баланс</span>
            </template>
            <template #body="{ data }">
                <span v-if="data.balance" class="text-sm white-space-nowrap font-medium">
                    {{ getFormatAmount(data.balance, 'usdt') }}
                </span>
            </template>
        </Column>
        
        <Column field="cap">
            <template #header>
                <span class="text-xs font-medium">Пополнено</span>
            </template>
            <template #body="{ data }">
                <span v-if="data.cap" class="text-sm white-space-nowrap">
                    {{ getFormatAmount(data.cap, 'usdt', 0) }}
                </span>
            </template>
        </Column>

        <Column field="spent">
            <template #header>
                <span class="text-xs font-medium">Потрачено</span>
            </template>
            <template #body="{ data }">
                <span v-if="data.spent" class="text-sm white-space-nowrap">
                    {{ getFormatAmount(data.spent, 'usdt', 0) }}
                </span>
            </template>
        </Column>

        <Column field="user_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">User Id</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 align-items-center" v-if="data.id">
                    <span class="flex text-xs my-auto overflow-hidden text-primary cursor-pointer" @click="goToUser(data.user_id)" style="max-width:5em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.user_id }}
                        </span>
                    </span>...
                    <Button icon="pi pi-copy" @click="copy(data.user_id)" size="small" class="border-round-md border-round-lg border-0" severity="secondary" outlined/>
                    <Button icon="pi pi-external-link" @click="goToUser(data.user_id, true)" size="small" class="border-round-md border-round-lg border-0" severity="info" outlined/>
                </div>
            </template>
        </Column>

        <Column field="vendor_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">Vendor</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.id">
                    <span class="flex text-sm">{{getVendorName(data.vendor_id)}}</span>
                    <Button icon="pi pi-copy" @click="copy(data.vendor_id)" size="small" class="border-round-md border-round-lg border-0" severity="info" outlined/>
                </div>
            </template>
        </Column>

        <Column field="program_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">Program Id</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.id">
                    <span class="flex text-sm">{{getProgramName(data.program_id)}}</span>
                    <Button icon="pi pi-copy" @click="copy(data.program_id)" size="small" class="border-round-md border-round-lg border-0" severity="info" outlined/>
                </div>
            </template>
        </Column>

        <Column field="created" >
            <template #header>
                <span class="text-xs">Создана</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center white-space-nowrap" v-if="data.created!=undefined">
                    <span class="flex text-sm">{{ formatDate(data.created)}}</span>
                </div>
            </template>
        </Column>

        <Column field="vendor_card_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">vID</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 align-items-center" v-if="data.id">
                    <span class="flex text-xs my-auto overflow-hidden" style="max-width:4em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.vendor_card_id }}
                        </span>
                    </span>...
                    <Button icon="pi pi-copy" @click="copy(data.vendor_card_id)" size="small" class="border-round-md border-round-lg border-0" severity="secondary" outlined/>
                </div>
            </template>
        </Column>

        <template #footer>
            <span class="text-sm font-medium">
                Всего карт: {{ totalRecords }} 
            </span>
        </template>

    </DataTable>

    <div class="flex flex-column align-items-center justify-content-center mt-3 px-2">
        <Skeleton height="2rem" v-if="loading" />
    </div>

</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import CardsTemplate from   '@/assets/json/vcards.json'

export default {
    data() {
        return {
            list: null,
            loading: false,
            selectedColumns: [],
            rows: 20,
            totalRecords: 0,
            lazyParams: {
                rows: 20,
                first: 0,
                filters: {},
                sort: {
                    _id: -1
                }
            },
            filters: {
                id: { value: null, matchMode: 'contains' },
                user_id: { value: null, matchMode: 'contains' },
                vendor_id: { value: null, matchMode: 'contains' }
            },
        }
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        cardsTemplateIndex() {
            return CardsTemplate.reduce((index, card) => {
                if (card.vendor_id && !index.vendor[card.vendor_id]) {
                    const vendorName = card.code && card.code.includes('_program_')
                        ? card.code.split('_program_')[0]
                        : card.vendor_id
                    index.vendor[card.vendor_id] = vendorName || card.vendor_id
                }
                if (card.program_id && !index.program[card.program_id]) {
                    index.program[card.program_id] = card.title || card.program_id
                }
                if (card.program_id && !index.color[card.program_id]) {
                    index.color[card.program_id] = {
                        background: card.background || '',
                        color: card.color || '',
                    }
                }
                return index
            }, {
                vendor: {},
                program: {},
                color: {},
            })
        },
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        exportCSV(){
            this.$refs.dt.exportCSV();
        },
        onPage(event) {
            this.lazyParams = event
            this.GetList()
        },
        onSort(event) {
            this.lazyParams = event
            this.GetList()
        },
        onFilter() {
            this.lazyParams.filters = this.filters
        },
        onRowSelect() {
            this.selectAll = this.selectedCustomers.length === this.totalRecords
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        getShortId(value){
            return this.helper.get_short_id(value)
        },
        goToUser(id, newTab = false) {
            if (newTab) window.open(`/admin/user_wallet/${id}/`, '_blank')
            else this.$router.push(`/admin/user_wallet/${id}/`)
        },
        goToCard(id, newTab = false) {
            if (newTab) window.open(`/admin/vcard/${id}/`, '_blank')
            else this.$router.push(`/admin/vcard/${id}/`)
        },
        getVendorName(vendorId) {
            if (!vendorId) return ''
            return this.cardsTemplateIndex.vendor[vendorId] || vendorId
        },
        getProgramName(programId) {
            if (!programId) return ''
            return this.cardsTemplateIndex.program[programId] || programId
        },
        getCardColorValue(programId) {
            if (!programId) return ''
            const cardColor = this.cardsTemplateIndex.color[programId]
            if (!cardColor) return ''
            return cardColor.background || cardColor.color || ''
        },
        getCardColorStyle(programId) {
            const cardColor = this.cardsTemplateIndex.color[programId]
            const backgroundColor = cardColor && cardColor.background ? cardColor.background : '#f0f0f0'
            const textColor = cardColor && cardColor.color ? cardColor.color : '#666666'
            return {
                width: '1.25rem',
                height: '1rem',
                backgroundColor: backgroundColor,
                color: textColor,
            }
        },
        getFormatAmount(value, currency, digits=2) {
            if(!value) return 0
            return this.helper.format_amount(value, currency, digits)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        async GetList(){
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
            try {
                let list = await this.connect.GetVcardList(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res => res)
                console.log('list', list)
                if (!list.result || !list.data) {
                    this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
                    return
                } else {
                    this.list = list.data
                    this.totalRecords = list.total || 0
                }
            } catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
            }
            this.loading = false
            console.log('list', this.list)
        },
        resetFilter() {
            this.filters.user_id.value = null
            this.filters.vendor_id.value = null
            this.lazyParams.filters = this.filters
            this.GetList()
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        // получим параметры из url
        const query = (this.$route.query) ? this.$route.query : {}
        if(query && query.user_id) {
            this.filters.user_id = {value: query.user_id, matchMode: 'contains'}
            this.lazyParams.filters = this.filters
        }

        await this.GetList().then(res=>res)
    },
}
</script>